module.exports = __webpack_public_path__ + "media/PaymentsAggregatePageModalGraphic.b399f431.svg";